"use strict"

import React, { useEffect, useState } from "react"

import { arrayWithContents } from "../../../utils"
import { withApplicationConfig } from "../../../../components/shared_components_registration"
import CommentSearch from "./CommentsSearch"
import RunCommentTable from "./RunCommentTable"
import FontSizeAdjuster from "../PerformanceMetricsPanel/FontSizeAdjuster"

function RunComments({ runsAvailable, actions, loading, run = {}, intl }) {
  const [runLoading, setRunLoading] = useState(true)
  const [err, setErr] = useState(false)
  const [filteredRunActions, setFilteredRunActions] = useState([])

  useEffect(() => {
    setRunLoading(loading)
    setErr(false)
  }, [loading])

  useEffect(() => {
    if (run.err) {
      setErr(true)
    } else {
      setErr(false)
    }
  }, [run])

  const [fontPercent, setFontPercent] = useState(80)

  return (
    <div className={"container-fluid"} style={{ height: "100%", position: "relative" }}>
      <div className={"row"} style={{ marginBottom: "3px" }}>
        <CommentSearch
          fontPct={fontPercent}
          filteredActions={filteredRunActions}
          actions={actions}
          intl={intl}
          setFilteredRunActions={setFilteredRunActions}
          disabled={loading || !arrayWithContents(actions)}
        />
      </div>
      <RunCommentTable
        fontPct={fontPercent}
        currentReactor={run.reactor}
        loading={runLoading || !run.reactor}
        showTable={runsAvailable}
        runActions={filteredRunActions}
        hadActions={actions.length > 0}
        err={err}
        intl={intl}
        onDash
      />
      <div style={{ padding: "0", position: "absolute", bottom: "0", right: "0", zIndex: "2" }}>
        <FontSizeAdjuster
          fontPercent={fontPercent}
          setFontPercent={setFontPercent}
          disabled={loading || !runsAvailable}
          intl={intl}
        />
      </div>
    </div>
  )
}

export default withApplicationConfig(RunComments)
